export default [
  {
    title: 'Дата заказа по убыванию',
    field: 'created_at.desc',
    options: {
      by: 'created_at',
      order: 'desc'
    }
  },
  {
    title: 'Дата заказа по возрастанию',
    field: 'created_at.asc',
    options: {
      by: 'created_at',
      order: 'asc'
    }
  },
  
  {
    title: 'Номер заказа по возрастанию',
    field: 'id.asc',
    options: {
      by: 'id',
      order: 'asc'
    }
  },
  {
    title: 'Номер заказа по убыванию',
    field: 'id.desc',
    options: {
      by: 'id',
      order: 'desc'
    }
  },

  {
    title: 'По поставкам(поздние)',
    field: 'supply.asc',
    options: {
      by: 'supply',
      order: 'asc'
    }
  },
  {
    title: 'По поставкам(ранние)',
    field: 'supply.desc',
    options: {
      by: 'supply',
      order: 'desc'
    }
  },
]